import { Image } from "@elements/ResponsiveImage/Image";

export type VideoPosterProps = {
  formattedTime?: string | undefined;
  src: string;
  posterDimensions?: {
    style?: string;
    width: number;
    height: number;
  };
};

export default function VideoPoster({
  formattedTime,
  src,
  posterDimensions,
}: VideoPosterProps) {
  const posterWidth = "lg:w-[202px] lg:h-[101px]";
  return (
    <div
      className={
        posterDimensions?.style
          ? posterDimensions.style
          : `w-[177px] h-[112px] ${posterWidth}`
      }
    >
      <div className={`bg-black-100 relative`}>
        <span
          className="text-white-100 bg-black-100 text-xs bg-opacity-60 absolute z-1 right-[3px] bottom-[3px] py-[2px] px-xxs"
          data-testid="time"
        >
          {formattedTime}
        </span>
        <Image
          objectFit="contain"
          src={src}
          className={`${posterDimensions ? posterDimensions.style : `w-[177px] h-[112px] ${posterWidth}`}`}
          alt="brightcove video"
          dataTestId="image"
          srcWidth={posterDimensions?.width || 259}
          srcHeight={posterDimensions?.height || 130}
        />
      </div>
    </div>
  );
}
